import { BaseScreen } from '@/core/component/base-screen.component'

export class AboutUs extends BaseScreen {
	constructor() {
		super({ title: 'About US' })
	}

	render() {
		return '<p>AboutUs</p>'
	}
}
